// extracted by mini-css-extract-plugin
export var numpadContainer = "_rr-1";
export var phoneButton = "_rr-0";